import * as Yup from 'yup';

export const actionValidation = Yup.object().shape({
  type: Yup.string().required('Ce champ doit être renseigné').default(''),
  createdAt: Yup.date().typeError('Erreur'),
  status: Yup.string().required('Ce champ doit être renseigné'),
  description: Yup.string().required('Ce champ doit être renseigné'),
});
